var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWalletCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.182,
    height: 24.182,
    viewBox: "0 0 24.182 24.182",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_25200",
    "data-name": "Group 25200",
    transform: "translate(-48 -365)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24801",
    "data-name": "Group 24801",
    transform: "translate(-1187.999 43.091)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1545",
    "data-name": "Ellipse 1545",
    cx: 12.091,
    cy: 12.091,
    r: 12.091,
    transform: "translate(1235.999 321.909)",
    fill: "#396"
  })), /*#__PURE__*/React.createElement("g", {
    id: "wallet-filled-money-tool",
    transform: "translate(54.293 353.568)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24406",
    "data-name": "Group 24406",
    transform: "translate(0 17.84)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7343",
    "data-name": "Path 7343",
    d: "M160.146,20l4.72-1.288-.25-.505a.665.665,0,0,0-.891-.3L159.5,20Z",
    transform: "translate(-157.379 -17.84)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7344",
    "data-name": "Path 7344",
    d: "M326.671,86.46a.665.665,0,0,0-.176.024l-1.109.3L322,87.711h5.519l-.207-.761A.664.664,0,0,0,326.671,86.46Z",
    transform: "translate(-317.719 -85.548)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7345",
    "data-name": "Path 7345",
    d: "M10.493,215.56H.666a.666.666,0,0,0-.642.491.688.688,0,0,0-.024.174v7.407a.665.665,0,0,0,.665.665h9.827a.665.665,0,0,0,.665-.665v-1.855H7.212a1.131,1.131,0,0,1-1.13-1.13v-1.479a1.129,1.129,0,0,1,1.129-1.129h3.946v-1.815A.663.663,0,0,0,10.493,215.56Z",
    transform: "translate(0 -212.931)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7346",
    "data-name": "Path 7346",
    d: "M497.477,436.935a.664.664,0,0,0-.233-.138.677.677,0,0,0-.215-.036h-3.964a.665.665,0,0,0-.665.665v1.48a.665.665,0,0,0,.665.665h3.964a.677.677,0,0,0,.215-.036.644.644,0,0,0,.233-.138.662.662,0,0,0,.217-.491v-1.48A.662.662,0,0,0,497.477,436.935Zm-3.024,1.363a.332.332,0,0,1-.332.332H493.9a.333.333,0,0,1-.332-.332v-.221a.326.326,0,0,1,.128-.261.336.336,0,0,1,.2-.072h.221a.332.332,0,0,1,.332.332v.221Z",
    transform: "translate(-485.853 -431.191)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletCircle);
export default __webpack_public_path__ + "static/media/wallet-circle.b4af66fb6979674aeb1849fc3e058a6c.svg";
export { ForwardRef as ReactComponent };